module.exports = __webpack_public_path__ + "img/product-preview-71.f94b8f5.png";